export const firstValue = (source: unknown, keys: string[]): unknown => {
  if (!source || typeof source !== 'object') return null;

  return keys.reduce((found: unknown, key) => {
    if (found !== null && found !== undefined && found !== '') return found;
    const value = key.split('.').reduce((current: unknown, path) => {
      if (current === null || current === undefined || typeof current !== 'object') return null;
      return (current as Record<string, unknown>)[path];
    }, source);

    return value !== null && value !== undefined && value !== '' ? value : null;
  }, null);
};

export const asStringOrNull = (value: unknown): string | null => {
  if (value === null || value === undefined || value === '') return null;
  return String(value);
};

export const asNumberOrNull = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? null : numberValue;
};

export const asBooleanOrNull = (value: unknown): boolean | null => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'sim') {
      return true;
    }
    if (
      normalized === 'false'
      || normalized === '0'
      || normalized === 'no'
      || normalized === 'nao'
      || normalized === 'não'
    ) {
      return false;
    }
  }
  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
  }
  return null;
};
